define([
	"csi/config",
	"dojo/_base/declare",
	"csi/table/New",
	"csi/xml",
	"./BOM/PartMaterialBOMSectionMixin"
], function(config, declare, New, xml, PartMaterialBOMSectionMixin) {

	return declare([New, PartMaterialBOMSectionMixin], {
		urlPartMaterial: null,

		getNewNodes: function() {
			// summary: return PartMaterial as a new node
			var node = this.m_cache.getNode(this.urlPartMaterial);
			return node ? [node] : null;
		},

		/**
		 * @override
		 * Fix ProductType if action invoked within group by type
		 */
		onCreatePopup(view) {
			const productTypeUrl = this.widget.getActionElementGroupProductType(this);
			if (productTypeUrl) {
				view.addFixedValue("ProductType", productTypeUrl);
			}

			this.inherited(arguments);
		},

		toWriterRequest: function(/*FormData?*/fd) {
			// summary: add PartMaterial url to request
			var call = this.inherited(arguments);
			this.urlPartMaterial = this.createNewUrl();
			call.addParameter("PartMaterialURL", xml.ATTR_REF, this.urlPartMaterial);
			return call;
		},

		getReturnNodeRequest: function(/*String[]*/urlsNew) {
			// summary: add PartMaterial url to request
			urlsNew.push(this.urlPartMaterial);
			return this.inherited(arguments);
		},

		_canNavigate: function() {
			// summary: disable Save & Go since action
			return false;
		},

		postProcessSuccess() {
			const cache = this.getCache();
			const bom = cache.getNode(this.getParent().__Parent__);
			const isRequireSection = config.getSubtypeSetting(bom.Subtype, "RequireSectionForPlacement");
			if (isRequireSection) {
				this.widget.refreshData();
			} else {
				this.inherited(arguments);
			}
		}
	});
});